import script from "./KioskTabletInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./KioskTabletInfo.vue?vue&type=script&setup=true&lang=js"

import "./KioskTabletInfo.vue?vue&type=style&index=0&id=e2b02026&scope=true&lang=css"

const __exports__ = script;

export default __exports__